module.exports = __webpack_public_path__ + "static/media/emoji.be33af5c.svg";